import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('token'),

  setUser: (user) => set({ user }),
  setToken: (token) => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
    set({ token });
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  isAuthenticated: () => {
    return localStorage.getItem('token') !== null;
  }
}));

export const useTraccarStore = create((set, get) => ({
  servers: [],
  setServers: (servers) => set({ servers }),
  addServer: (server) => set({ servers: [server, ...get().servers] }),
  removeServer: (id) => set({ servers: get().servers.filter(s => s.id !== id) })
}));

export const useTemplateStore = create((set, get) => ({
  templates: [],
  setTemplates: (templates) => set({ templates }),
  addTemplate: (template) => set({ templates: [template, ...get().templates] }),
  removeTemplate: (id) => set({ templates: get().templates.filter(t => t.id !== id) })
}));

export const useShipmentStore = create((set, get) => ({
  shipments: [],
  stats: null,
  setShipments: (shipments, stats) => set({ shipments, stats }),
  addShipment: (shipment) => set({ shipments: [shipment, ...get().shipments] })
}));

export const useLogStore = create((set) => ({
  logs: [],
  stats: null,
  setLogs: (logs, stats) => set({ logs, stats })
}));

export const useConfigStore = create((set) => ({
  config: null,
  setConfig: (config) => set({ config })
}));
